<template>
    <div>
    <h3>Site Number Requests</h3>
    <div class="wrapper">
        <div  class="row row-wider">
        <div class="col-md-12">
            <form v-if="type ==='search'" @submit.prevent="loadData" class="form-horizontal">
                <div class="form-group">
                    <div class="col-sm-2">
                        <label for="SearchSiteName">Name/Identifier</label>
                    </div>
                    <div class="col-sm-3">
                        <input class="form-control" type="text" name="SearchSiteName" v-model="searchDto.siteName">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchFieldOrgNumber">Field Org. Number</label>
                    </div>
                    <div class="col-sm-4">
                        <input class="form-control" type="text" name="searchFieldOrgNumber" v-model="searchDto.fieldOrgNumber">
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-2">
                        <label for="searchProjectName">Project Name</label>
                    </div>
                    <div class="col-md-3">
                        <input class="form-control" type="text" name="searchProjectName" v-model="searchDto.projectName">
                    </div>
                    <div class="col-sm-2 col-sm-offset-1">
                        <label for="searchStatus">Status</label>
                    </div>
                    <div class="col-sm-3">
                        <select class="form-control" name="searchStatus" v-model="searchDto.workflowStatusId">
                            <option value="">Select Workflow Status</option>
                            <option v-for="status in workflowList" :value="status.workflowStatusId" :key="status.workflowStatusId">{{status.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-md-2">
                        <button class="btn btn-primary" type="submit" name="button" v-on:click="loadData">Search</button>
                    </div>
                </div>
            </form>
            <div class="pull-right" v-if="type === 'search'">
            <router-link to="/SiteNumberRequest" tag="button" class="btn btn-primary btn-block">Add Off-inventory Site Number Request</router-link>
            </div>
            <loader v-if="loading"/>
            <div>
            <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options">
                <template slot="edit" slot-scope="props">
                <div style="text-align: center;">
                    <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.siteNumberRequestId)"></a> -->
                    <router-link :to="{ path: '/SiteNumberRequest/' + props.row.siteNumberRequestId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                </div>
                </template>
            </v-client-table>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import siteNumberRequestService from '../services/siteNumberRequestService'
import workflowService from '../services/workflowService'
import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    props: {
        type: {
            type: String,
            default: 'search'
        }
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            list: null,
            searchDto: {
                searchLimit: 400
            },
            workflowList: [],
            gridSpec: {
                columns: ['edit', 'workflowStatusDescription', 'siteName', 'siteTypeDescription', 'projectName', 'agencyDescription', 'clientDescription', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        workflowStatusDescription: 'Status',
                        siteName: 'Site Name/Identifier',
                        siteTypeDescription: 'Type',
                        projectName: 'Project Name',
                        agencyDescription: 'Agency',
                        clientDescription: 'Client',
                        fieldOrgDescription: 'Field Org',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Projects', 'mounted')

        this.loadData()
        this.loadWorkflow()
    },
    methods: {
        loadData () {
            loggingService.log(this.isDebug, 'SiteNumberRequests', 'loadData')

            var handle = this
            handle.list = null
            if (this.type === 'search') {
                siteNumberRequestService.search(this.$http, this.searchDto).then(function (response) {
                    loggingService.log(handle.isDebug, 'SiteNumberRequests', 'search complete')

                    handle.gridSpec.tableData = response.data
                    handle.loading = false
                })
            } else if (this.type === 'todo') {
                siteNumberRequestService.todo(this.$http, this.searchDto).then(function (response) {
                    loggingService.log(handle.isDebug, 'SiteNumberRequests', 'todo complete')

                    handle.gridSpec.tableData = response.data
                    handle.gridSpec.columns = ['edit', 'workflowStatusDescription', 'siteName', 'siteTypeDescription', 'projectName', 'agencyDescription', 'clientDescription', 'fieldOrgDescription', 'createdDate']
                    handle.loading = false
                })
            } else {
                loggingService.log(handle.isDebug, 'SiteNumberRequests', 'SiteNumberRequests.loadData - unknown type: ' + this.type)
            }
        },
        loadWorkflow () {
            workflowService.listByWorkflowId(this.$http, workflowService.WorkflowEnum.SiteNumberRequest).then(result => {
                this.workflowList = result.data.reverse()
            })
        },
        editRow (id) {
            loggingService.log(this.isDebug, 'SiteNumberRequests', 'editRow, id: ' + id)

            this.$router.push('/SiteNumberRequest/' + id)
        }
    }
}
</script>




// WEBPACK FOOTER //
// SiteNumberRequests.vue?61f4e958